import { Typography, withTheme } from '@material-ui/core';
import styled from 'styled-components';

export default withTheme(styled(Typography)`
  margin-top: 10px;
  display: ${({ theme: { breakpoints } }) =>
    breakpoints.up('sm') ? 'inline-block' : 'block'};
`);
